//import React from 'react';
import React, { useEffect } from 'react';
import Banner from '../Casino/Banner';
import Categories from './Categories';
import { useSelector } from 'react-redux';
import GameList from './GameList';
import GameListCarousel from './GameListCarousel';
import New from './New';
import CustomModal from '../Casino/CustomModal'
import Util from '../../helper/Util';
import { Translate } from '../../localization';

const LiveCasino = () => {

    const { casinoSearchValue } = useSelector((state) => state.casino);
    useEffect(() => {
        document.documentElement.setAttribute('lang', Translate.getLanguage());
        document.title = Translate.DocumentHeader;
        const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        Translate.DocumentDescriptionLiveCasino
      );
      const canonicalTag = document.querySelector('link[rel="canonical"]');
      if (canonicalTag) {
          canonicalTag.setAttribute(
              'href',
              `https://www.jackpotct.com/${Translate.getLanguage()}/d/casino`
          );
      }
    }

      }, []);

    return (
        <div id='scrollableDiv' className='casino-body'>
            <div className="banner-categories">
                <div className="casino-bg casino-parent-div casino-width-align">
                    <div class="container scrool-text">
                        <div class="heading-row">
                            <div class="announcement-icon-box">
                                <div class="announcement-icon">
                                    <img title="Announcement icon" alt="info" src="//images.ctfassets.net/scslmvjv6lim/OF1lF3nDKZKY2259lbmQa/af118f3cbeff2033175ebdd31ab7e37c/annon.svg" />
                                </div>
                            </div>
                            <div class="announcement-text">
                            {Translate.announceMsg} 
                            </div>
                        </div>
                    </div>
                </div>
                <Banner />
            </div>

            <div className='w-100'>
                <Categories />
                {casinoSearchValue.length == 0 ?
                    <>
                        <New />
                        <GameListCarousel
                            search={'Andar Bahar'}
                        />
                        <GameListCarousel
                            search={'Baccarat'}
                        />
                        <GameListCarousel
                            search={'Keno'}
                        />
                        <GameListCarousel
                            search={'Blackjack'}
                        />
                        <GameListCarousel
                            search={'Sic Bo'}
                        />
                        <GameListCarousel
                            search={'Poker'}
                        />
                        <GameListCarousel
                            search={'Dragon tiger'}
                        />
                        <GameListCarousel
                            search={'Roulette'}
                        />
                    </>
                    :
                    <GameList />
                }
            </div>
        </div>
    );
};

export default LiveCasino;
